import { BaseRouteService } from 'core/services';

class CoreUserInfoRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'core-user-infos/';
	}

	find(filter) {
		return super.find(this.base + 'search', filter);
	}

	update(resource, sourceOfChange) {
		return super.update(this.base + '{id}/?sourceOfChange={sourceOfChange}', resource , {sourceOfChange});
	}
}

export default CoreUserInfoRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/CoreUserInfoRouteService.js